<template lang='pug' src='./accessibility-statement.pug'></template>

<script>
import Loader from 'components/loader/loader'

export default {
  name: 'AccessibilityStatement',
  computed: {
    props () {
      return this.$store.state.pages.technologies
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader
  },
  data () {
    return {
      companyName: 'Merrick Orthodontics', // Fill this in
      domain: "<a href='https://www.merrickortho.com'>merrickortho.com</a>", // Fill this in
      email: "<a href='mailto:braces@sukoffortho.com'>braces@sukoffortho.com</a>", // Fill this in
      phone: "<a href='tel:+15168683131'>516-868-3131</a>", // Fill this in
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// accessibility-statement.vue?7a83206a